export default __webpack_public_path__ + "static/media/elevate-bbl-poster-3.22ec60cc.jpg";